var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading-screen"},[_c('div',[_c('div',{staticClass:"loadingOverride"},[_c('div',{staticClass:"row"},[_c('span',[_vm._v(_vm._s(_vm.message))])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"loader",style:({ '--progress': _vm.progress })})])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }